<template>
  <div class="PuntosNuevo">
    <h1>Punto nuevo</h1>
    <md-layout md-flex="100" md-align="center">
      <md-layout md-column md-flex-xsmall="100" md-flex-small="100" md-flex-medium="30" md-flex-large="20" md-flex-xlarge="15">
        <div class="md-title w-100">Información del cliente</div>
        <div class="m-t-16">
          <strong>Cuenta:</strong> {{cliente.cuenta}}<br>
          <strong>Razón social:</strong> {{cliente.nombre}}<br>
          <strong>R.F.C.:</strong> {{cliente.rfc}}<br>
          <strong>Email_</strong> {{cliente.email}}<br>
          <strong>Teléfono:</strong>
          <a :href="`tel:${cliente.telefono}`">{{cliente.telefono}}</a><br>
          <strong>Domicilio:</strong>
          {{cliente.calle+' #'+cliente.numero}}.<br> Colonia {{cliente.colonia}}. CP {{cliente.codigo_postal}}<br> {{cliente.municipio}}, {{cliente.estado}}<br>
          <strong>Notas:</strong> {{cliente.notas}}<br>
        </div>
      </md-layout>
      <md-layout md-column md-flex-xsmall="100" md-flex-small="100" md-flex-medium="60" md-flex-large="50" md-flex-xlarge="30">
        <md-card class="w-100">
          <md-card-header>
            <div class="md-title">Información del punto</div>
            <div class="md-subhead">Los campos marcados con * son obligatorios</div>
          </md-card-header>
          <md-card-content>
            <md-layout md-flex="100" md-gutter="24">
              <md-layout md-flex="100">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_nombre }">
                  <label>Nombre del punto</label>
                  <md-input v-model="punto.nombre_pun" required></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="50" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_guardias }">
                  <label>Guardias requeridos</label>
                  <md-input v-model="punto.guardias_pun" type="number" min="1" required></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="50" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_presupuesto }">
                  <label>Presupuesto</label>
                  <md-input v-model="punto.presupuesto_pun" type="number" step=".01" min="0" required></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="70" md-flex-small="70" md-flex-medium="70" md-flex-large="70" md-flex-xlarge="70">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_calle }">
                  <label>Calle</label>
                  <md-input v-model="punto.calle_pun" required></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="30" md-flex-small="30" md-flex-medium="30" md-flex-large="30" md-flex-xlarge="30">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_num_ext }">
                  <label># ext</label>
                  <md-input v-model="punto.num_ext_pun" required></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="70" md-flex-small="70" md-flex-medium="70" md-flex-large="70" md-flex-xlarge="70">
                <md-input-container>
                  <label>Colonia</label>
                  <md-input v-model="punto.colonia_pun"></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="30" md-flex-small="30" md-flex-medium="30" md-flex-large="30" md-flex-xlarge="30">
                <md-input-container>
                  <label>C.P.</label>
                  <md-input v-model="punto.cp_pun"></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="50" md-flex-small="50" md-flex-medium="50" md-flex-large="50" md-flex-xlarge="50">
                <md-input-container>
                  <label>Municipio</label>
                  <md-input v-model="punto.municipio_pun"></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="50" md-flex-small="50" md-flex-medium="50" md-flex-large="50" md-flex-xlarge="50">
                <md-input-container>
                  <label>Estado</label>
                  <md-input v-model="punto.estado_pun"></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="50" md-flex-small="50" md-flex-medium="50" md-flex-large="50" md-flex-xlarge="50">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_id_cnt }">
                  <label for="id_cnt_pun">Contrato</label>
                  <md-select name="id_cnt_pun" id="id_cnt_pun" v-model="punto.id_cnt_pun" required md-dense>
                    <md-option v-for="cnt in contratos" :value="cnt.id_cnt" :key="cnt.id_cnt">
                      {{ cnt.titulo_cnt }}
                    </md-option>
                  </md-select>
                </md-input-container>
              </md-layout>
              <md-layout md-flex="100">
                <md-input-container>
                  <label>Notas</label>
                  <md-textarea v-model="punto.notas_pun"></md-textarea>
                </md-input-container>
              </md-layout>
            </md-layout>
          </md-card-content>
          <md-card-actions>
            <md-button @click.native="copiarInformacionCliente()">
              Usar información del cliente
            </md-button>
          </md-card-actions>
        </md-card>
        <md-card class="w-100 m-t-24" m>
          <md-card-header>
            <div class="md-title">Turnos</div>
          </md-card-header>
          <md-card-content>
            <md-layout md-flex="100" md-gutter="24" md-align="center">
              <md-layout md-column md-flex-xsmall="40" md-flex-small="40" md-flex-medium="25" md-flex-large="20" md-flex-xlarge="20">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_inicio_tur }">
                  <label for="inicio_tur">Inicio</label>
                  <md-select name="inicio_tur" id="inicio_tur" v-model="turno.inicio_tur">
                    <md-option value="1 AM">1 AM</md-option>
                    <md-option value="2 AM">2 AM</md-option>
                    <md-option value="3 AM">3 AM</md-option>
                    <md-option value="4 AM">4 AM</md-option>
                    <md-option value="5 AM">5 AM</md-option>
                    <md-option value="6 AM">6 AM</md-option>
                    <md-option value="7 AM">7 AM</md-option>
                    <md-option value="8 AM">8 AM</md-option>
                    <md-option value="9 AM">9 AM</md-option>
                    <md-option value="10 AM">10 AM</md-option>
                    <md-option value="11 AM">11 AM</md-option>
                    <md-option value="12 AM">12 AM</md-option>
                    <md-option value="1 PM">1 PM</md-option>
                    <md-option value="2 PM">2 PM</md-option>
                    <md-option value="3 PM">3 PM</md-option>
                    <md-option value="4 PM">4 PM</md-option>
                    <md-option value="5 PM">5 PM</md-option>
                    <md-option value="6 PM">6 PM</md-option>
                    <md-option value="7 PM">7 PM</md-option>
                    <md-option value="8 PM">8 PM</md-option>
                    <md-option value="9 PM">9 PM</md-option>
                    <md-option value="10 PM">10 PM</md-option>
                    <md-option value="11 PM">11 PM</md-option>
                    <md-option value="12 PM">12 PM</md-option>
                  </md-select>
                </md-input-container>
              </md-layout>
              <md-layout md-column md-flex-xsmall="40" md-flex-small="40" md-flex-medium="25" md-flex-large="20" md-flex-xlarge="20">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_fin_tur }">
                  <label for="fin_tur">Fin</label>
                  <md-select name="fin_tur" id="fin_tur" v-model="turno.fin_tur">
                    <md-option value="1 AM">1 AM</md-option>
                    <md-option value="2 AM">2 AM</md-option>
                    <md-option value="3 AM">3 AM</md-option>
                    <md-option value="4 AM">4 AM</md-option>
                    <md-option value="5 AM">5 AM</md-option>
                    <md-option value="6 AM">6 AM</md-option>
                    <md-option value="7 AM">7 AM</md-option>
                    <md-option value="8 AM">8 AM</md-option>
                    <md-option value="9 AM">9 AM</md-option>
                    <md-option value="10 AM">10 AM</md-option>
                    <md-option value="11 AM">11 AM</md-option>
                    <md-option value="12 AM">12 AM</md-option>
                    <md-option value="1 PM">1 PM</md-option>
                    <md-option value="2 PM">2 PM</md-option>
                    <md-option value="3 PM">3 PM</md-option>
                    <md-option value="4 PM">4 PM</md-option>
                    <md-option value="5 PM">5 PM</md-option>
                    <md-option value="6 PM">6 PM</md-option>
                    <md-option value="7 PM">7 PM</md-option>
                    <md-option value="8 PM">8 PM</md-option>
                    <md-option value="9 PM">9 PM</md-option>
                    <md-option value="10 PM">10 PM</md-option>
                    <md-option value="11 PM">11 PM</md-option>
                    <md-option value="12 PM">12 PM</md-option>
                  </md-select>
                </md-input-container>
              </md-layout>
              <md-layout md-column md-flex-xsmall="20" md-flex-small="20" md-flex-medium="15" md-flex-large="15" md-flex-xlarge="15">
                <md-button class="md-icon-button md-raised md-accent" @click.native="agregarTurno()">
                  <md-icon>add</md-icon>
                </md-button>
              </md-layout>
              <md-layout md-column md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="100" md-flex-xlarge="100">
                <md-table>
                  <md-table-header>
                    <md-table-row>
                      <md-table-head></md-table-head>
                      <md-table-head>Turno</md-table-head>
                    </md-table-row>
                  </md-table-header>
                  <md-table-body>
                    <md-table-row v-for="t in turnos" :key="t.id_tur">
                      <md-table-cell>
                        <md-button class="md-icon-button" @click.native="removerTurno(t)">
                          <md-icon>delete</md-icon>
                        </md-button>
                      </md-table-cell>
                      <md-table-cell>{{t.inicio_tur}} a {{t.fin_tur}}</md-table-cell>
                    </md-table-row>
                  </md-table-body>
                </md-table>
              </md-layout>
            </md-layout>
          </md-card-content>
          <md-card-actions>
            <router-link tag="md-button" to="/puntos">Cancelar</router-link>
            <md-button @click.native="guardarPunto()" class="md-raised md-primary">Guardar punto</md-button>
          </md-card-actions>
        </md-card>
      </md-layout>
    </md-layout>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
export default {
  name: "PuntosNuevo",
  methods: {
    obtenerContratos() {
      this.$route.params.id;
      this.$http
        .post("contratos", {
          token: this.$session.get("token"),
          id: this.$route.params.cliente,
          tipo: "servicios_guardias"
        })
        .then(
          response => {
            if (response.status === 200 && "contratos" in response.body) {
              this.contratos = response.body.contratos;
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
            this.$router.push("/punto/cliente");
          }
        );
    },
    obtenerCliente() {
      this.$route.params.id;
      this.$http
        .post("clientes/obtener", {
          token: this.$session.get("token"),
          id: this.$route.params.cliente
        })
        .then(
          response => {
            if (response.status === 200 && "cliente" in response.body) {
              this.cliente = response.body.cliente;
              this.punto.id_cli_pun = response.body.cliente.id_cliente;
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
              this.$router.push("/punto/cliente");
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
            this.$router.push("/punto/cliente");
          }
        );
    },
    copiarInformacionCliente() {
      this.punto.calle_pun = this.cliente.calle;
      this.punto.num_ext_pun = this.cliente.numero;
      this.punto.colonia_pun = this.cliente.colonia;
      this.punto.cp_pun = this.cliente.codigo_postal;
      this.punto.municipio_pun = this.cliente.municipio;
      this.punto.estado_pun = this.cliente.estado;
      this.punto.notas_pun = this.cliente.notas;
    },
    guardarPunto() {
      if (this.validarInformacion() && this.existenTurnosRegistrados()) {
        this.$http
          .post("puntos/guardar", {
            token: this.$session.get("token"),
            data: this.punto,
            cnt: this.punto.id_cnt_pun,
            turnos: this.turnos
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                Snackbar.show({
                  text: response.body.msg,
                  actionText: "Cerrar",
                  showAction: false,
                  pos: "top-right"
                });
                this.abrirVentanaContrato(response.body.punto);
                this.$router.push("/puntos");
              } else {
                Snackbar.show({
                  text: response.body.error,
                  actionText: "Cerrar",
                  showAction: false,
                  pos: "top-right",
                  backgroundColor: "#F44336",
                  actionTextColor: "#FFF"
                });
              }
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      }
    },
    validarInformacion() {
      !this.punto.nombre_pun
        ? (this.val.v_nombre = true)
        : (this.val.v_nombre = false);
      !this.punto.guardias_pun
        ? (this.val.v_guardias = true)
        : (this.val.v_guardias = false);
      !this.punto.presupuesto_pun
        ? (this.val.v_presupuesto = true)
        : (this.val.v_presupuesto = false);
      !this.punto.calle_pun
        ? (this.val.v_calle = true)
        : (this.val.v_calle = false);
      !this.punto.num_ext_pun
        ? (this.val.v_num_ext = true)
        : (this.val.v_num_ext = false);
      !this.punto.id_cnt_pun
        ? (this.val.v_id_cnt = true)
        : (this.val.v_id_cnt = false);
      if (
        this.val.v_nombre ||
        this.val.v_guardias ||
        this.val.v_presupuesto ||
        this.val.v_calle ||
        this.val.v_num_ext
      ) {
        Snackbar.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    },
    agregarTurno() {
      if (this.validarSelectsTurno()) {
        this.turnos.push({
          inicio_tur: this.turno.inicio_tur,
          fin_tur: this.turno.fin_tur
        });
        this.turno.inicio_tur = null;
        this.turno.fin_tur = null;
        this.val.v_inicio_tur = null;
        this.val.v_fin_tur = null;
      }
    },
    removerTurno(index) {
      this.turnos.splice(index, 1);
    },
    abrirVentanaContrato(id_p) {
      window.open(
        "http://api.grupoalarcom.mx/pdf/contratos?punto=" + id_p,
        "_blank"
      );
    },
    existenTurnosRegistrados() {
      if (this.turnos.length > 0) {
        return true;
      } else {
        Snackbar.show({
          text: "Para registrar el punto debe asignar los turnos",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      }
    },
    validarSelectsTurno() {
      !this.turno.inicio_tur
        ? (this.val.v_inicio_tur = true)
        : (this.val.v_inicio_tur = false);
      !this.turno.fin_tur
        ? (this.val.v_fin_tur = true)
        : (this.val.v_fin_tur = false);
      if (this.val.v_fin_tur || this.val.v_inicio_tur) {
        Snackbar.show({
          text: "Por favor seleccione los horarios del turno",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerCliente();
  },
  mounted() {
    this.obtenerContratos();
  },
  data() {
    return {
      msg: "Inicio",
      contratos: [],
      cliente: {
        cuenta: null,
        nombre: null,
        rfc: null,
        email: null,
        telefono: null,
        estado: null,
        municipio: null,
        ciudad: null,
        calle: null,
        colonia: null,
        numero: null,
        codigo_postal: null,
        notas: null
      },
      punto: {
        id_cli_pun: null,
        nombre_pun: null,
        guardias_pun: null,
        presupuesto_pun: null,
        calle_pun: null,
        num_ext_pun: null,
        colonia_pun: null,
        cp_pun: null,
        municipio_pun: null,
        estado_pun: null,
        id_cnt_pun: null,
        notas_pun: null
      },
      turno: {
        inicio_tur: null,
        fin_tur: null
      },
      turnos: [],
      val: {
        v_nombre: null,
        v_guardias: null,
        v_presupuesto: null,
        v_calle: null,
        v_num_ext: null,
        v_inicio_tur: null,
        v_fin_tur: null,
        v_id_cnt: null
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// PuntosNuevo.vue?2bc2db8e